module.exports = __webpack_public_path__ + "static/media/woman-writing.8fb3c184.jpg";